import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import AppLayout from "./components/AppLayout";
import Home from "./pages/Home";
import Profile from "./pages/Profile";
import HRDashboard from "./pages/hr/HRDashboard";
import EmployeeMaster from "./pages/hr/EmployeeMaster";
import HRProfileReview from "./pages/hr/HRProfileReview";
import Onboarding from "./pages/hr/Onboarding";
import Attendance from "./pages/hr/Attendance";
import LeaveManagement from "./pages/hr/LeaveManagement";
import HRApplications from "./pages/hr/HRApplications";
import HRContacts from "./pages/hr/HRContacts";
import PerformanceAppraisal from "./pages/hr/PerformanceAppraisal";
import Compensation from "./pages/hr/Compensation";
import HRReports from "./pages/hr/HRReports";
import HRSettings from "./pages/hr/HRSettings";
import HRActivityLog from "./pages/hr/HRActivityLog";
import Offboarding from "./pages/hr/Offboarding";
import ProtectedRoute from "./components/security/ProtectedRoute";
import { QuoteProvider } from "./context/QuoteContext";
import EnterprisePlaceholderPage from "./pages/enterprise/EnterprisePlaceholderPage";
import MESPlantMaster from "./pages/mes/factory/MESPlantMaster";
import AppPreferences from "./pages/AppPreferences";
import { applyPreferences, readLanguage, readTheme } from "./i18n/hrPackagePreferences";
import "./styles/appPreferences.css";

const protectedPage=(roles,Page)=><ProtectedRoute allowedRoles={roles}><Page/></ProtectedRoute>;
function App(){applyPreferences(readLanguage(),readTheme());return <QuoteProvider><BrowserRouter><Routes><Route element={<AppLayout/>}>
<Route path="/" element={<Home/>}/><Route path="/profile" element={<Profile/>}/>
<Route path="/hr/dashboard" element={protectedPage(["HR","HRAdmin","Admin"],HRDashboard)}/>
<Route path="/hr/employees" element={protectedPage(["HR","HRAdmin","Admin"],EmployeeMaster)}/>
<Route path="/hr/profile-review" element={protectedPage(["HR","HRAdmin","Admin","Manager"],HRProfileReview)}/>
<Route path="/hr/activity-log" element={protectedPage(["HR","HRAdmin","Admin","Manager"],HRActivityLog)}/>
<Route path="/hr/onboarding" element={protectedPage(["HR","HRAdmin","Admin"],Onboarding)}/>
<Route path="/hr/exit" element={protectedPage(["Employee","Manager","HR","HRAdmin","Admin"],Offboarding)}/>
<Route path="/hr/attendance" element={protectedPage(["Employee","Manager","HR","HRAdmin","Admin"],Attendance)}/>
<Route path="/hr/leave" element={protectedPage(["Employee","Manager","HR","HRAdmin","Admin"],LeaveManagement)}/>
<Route path="/hr/applications" element={protectedPage(["Employee","Manager","HR","HRAdmin","Admin"],HRApplications)}/>
<Route path="/hr/contacts" element={protectedPage(["Employee","Manager","HR","HRAdmin","Admin"],HRContacts)}/>
<Route path="/hr/appraisal" element={protectedPage(["Employee","Manager","HR","HRAdmin","Admin"],PerformanceAppraisal)}/>
<Route path="/hr/compensation" element={protectedPage(["HRAdmin","Admin","Finance"],Compensation)}/>
<Route path="/hr/reports" element={protectedPage(["HR","HRAdmin","Admin"],HRReports)}/>
<Route path="/hr/settings" element={protectedPage(["HRAdmin","Admin"],HRSettings)}/>
<Route path="/enterprise/app-settings" element={<AppPreferences/>}/>
<Route path="/mes/factory-setup/plants" element={<MESPlantMaster/>}/>
<Route path="/mes/*" element={<EnterprisePlaceholderPage/>}/><Route path="/inventory/*" element={<EnterprisePlaceholderPage/>}/><Route path="/procurement/*" element={<EnterprisePlaceholderPage/>}/><Route path="/finance/*" element={<EnterprisePlaceholderPage/>}/><Route path="/governance/*" element={<EnterprisePlaceholderPage/>}/><Route path="/analytics/*" element={<EnterprisePlaceholderPage/>}/><Route path="/executive/*" element={<EnterprisePlaceholderPage/>}/><Route path="/enterprise/*" element={<EnterprisePlaceholderPage/>}/>
<Route path="*" element={<EnterprisePlaceholderPage/>}/>
</Route></Routes></BrowserRouter></QuoteProvider>}
export default App;
